// ─────────────────────────────────────────────────────────────────────
// THE TOKEN FAMILIES, mirrored from the API (`sessions.ts`, `memberSessions.ts`).
//
// Four credentials, disjoint by prefix, and the prefix is the ONLY thing that
// tells them apart once one is in a variable:
//
//   `sps_`  a club/account session — a club administrator (#186)
//   `spm_`  a member session — a player in the member app (#185)
//   `spd_`  a pad device
//   `spo_`  an onboarding grant, which proves a mailbox and authorizes nothing
//
// Duplicated rather than imported because the web bundle does not depend on the
// API package — but they are a CONTRACT, and `api-http-default-deps.test.ts`
// fails if the two drift apart.
//
// THEY LIVE HERE RATHER THAN IN `http.ts` so that `memberSession` can read them
// too (#741 review). `http.ts` imports the sessions, so a session importing
// `http.ts` back would be a cycle — and a third hand-written copy of `'spm_'`
// is exactly how a contract stops being one.
// ─────────────────────────────────────────────────────────────────────

export const CLUB_TOKEN_PREFIX = 'sps_';
export const MEMBER_TOKEN_PREFIX = 'spm_';
